export const gitCommit = '655c838d'
